@if ((isTowMapFirst$ | async) && shouldDisplay()) {
  <ion-row class="badge ion-align-items-center ion-padding-horizontal" [ngClass]="{'map' : variation === 'map', 'card' : variation === 'card'}">
    @if (icon) {
      <ion-col size="auto">
        <aaa-text size="headline" display="flex" [color]="color">
          <ion-icon [icon]="icon"></ion-icon>
        </aaa-text>
      </ion-col>
    }
    <ion-col size="auto">
      <aaa-text i18n size="footnote" display="inline" [color]="color">
        {{ badge }}
      </aaa-text>
    </ion-col>
  </ion-row>
}